import { Link } from "wouter";
import { RefreshCcw, Home, Search } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-b from-neutral-lighter to-neutral-dark">
      <div className="w-full max-w-lg p-10 mx-4 bg-white rounded-xl shadow-xl animate-fade-in-up">
        <div className="text-center mb-8">
          <div className="text-9xl font-extrabold text-primary animate-scale-in">
            404
          </div>
          
          <div className="animate-fade-in animation-delay-300">
            <h1 className="text-3xl font-bold text-neutral-darker mt-6">Seite nicht gefunden</h1>
            <div className="w-24 h-1 bg-primary mx-auto my-4 rounded-full"></div>
          </div>
        </div>

        <p className="text-gray-600 text-center mb-8 text-lg animate-fade-in animation-delay-500">
          Die von Ihnen gesuchte Seite existiert nicht oder wurde verschoben.
        </p>
        
        <div className="flex flex-col sm:flex-row justify-center space-y-3 sm:space-y-0 sm:space-x-4 animate-fade-in-up animation-delay-700">
          <Link href="/">
            <button className="flex items-center justify-center bg-primary hover:bg-primary-dark text-white font-medium py-3 px-6 rounded-lg transition duration-300 w-full sm:w-auto hover:scale-105 active:scale-95">
              <Home className="mr-2 h-5 w-5" /> Zur Startseite
            </button>
          </Link>
          
          <Link href="/restaurants">
            <button className="flex items-center justify-center bg-green-600 hover:bg-green-700 text-white font-medium py-3 px-6 rounded-lg transition duration-300 w-full sm:w-auto hover:scale-105 active:scale-95">
              <Search className="mr-2 h-5 w-5" /> Restaurants entdecken
            </button>
          </Link>
        </div>
        
        <div className="mt-10 pt-6 border-t border-gray-200 text-center text-gray-500 text-sm animate-fade-in animation-delay-1000">
          <p className="flex items-center justify-center">
            <RefreshCcw className="h-4 w-4 mr-2 animate-spin-slow" /> 
            Möchten Sie zur vorherigen Seite zurückkehren? <button 
              onClick={() => window.history.back()} 
              className="ml-1 text-primary hover:text-primary-dark font-medium hover:underline"
            >
              Zurück
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
